import React from "react";
import ForgotPassForm from "../../components/auth-forms/forgot-pass-form/ForgotPassForm";

export default function ForgotPassPage() {
  return (
    <div>
      <ForgotPassForm />
    </div>
  );
}
